export enum NumberFormat {
  DOT = 'dot',
  COMMA = 'comma',
}

export const NumberFormatExample: Record<NumberFormat, string> = {
  [NumberFormat.DOT]: '1.50',
  [NumberFormat.COMMA]: '1,50',
};
